import { useBookingContext } from '@providers/booking'
import { AdyenPayment } from './adyen_payment/adyen_payment'
import { TiledPayment } from './tiled_payment/tiled_payment'

export const Payment = () => {
  const bookingCtx = useBookingContext()

  if (bookingCtx.state.data?.reservation?.order?.location?.payFacConfig?.type === 'ADYEN') {
    return <AdyenPayment />
  }

  return <TiledPayment />
}
